/**
 * alertTypes.js
 * Written by: Alex Kasemir
 */
const initialState = {
  signUp: null,
  share: null,
};
/**
 * Description of the alertTypes reducer
 */
const alertTypes = (state = initialState, action) => {
  switch (action.type) {
    case `SET_SIGN_UP_MODAL_SUCCESS`:
      return {
        ...state,
        signUp: action.kind,
      };
    case `SET_SHARE_CONTENT_SUCCESS`:
      return {
        ...state,
        share: action.kind,
      };
    default:
      return state;
  }
};

export default alertTypes;
